import { Award, Clock } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

/**
 * Quran Fluency Certified tab — official certification isn't sellable yet
 * (LEVEL2_COMING_SOON, see Certificate.jsx), so this tab just says so
 * instead of showing per-module eligibility detail.
 */
export default function TestCertified() {
  const { t } = useI18n();
  return (
    <div className="rounded-2xl bg-white border border-[#E7E0D2] p-8 text-center" data-testid="certified-view">
      <Award className="w-8 h-8 text-[#9CA3AF] mx-auto" />
      <div className="mt-3 font-heading text-lg text-[#1F2937]">{t("rd.certified_coming_soon_title")}</div>
      <div className="mt-1.5 inline-flex items-center gap-1.5 text-xs text-[#B45309] bg-[#FFF7ED] border border-[#FED7AA] rounded-full px-3 py-1">
        <Clock className="w-3.5 h-3.5" /> {t("rd.certified_coming_soon_badge")}
      </div>
    </div>
  );
}
